import { Component, Input } from '@angular/core';
import { APP_STRING_KEYS } from 'src/app/_constants';
import { AppStringsService } from 'src/app/_services';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';

@Component({
    selector: 'app-app-string',
    templateUrl: './app-string.component.html',
    styleUrls: ['./app-string.component.scss']
})
export class AppStringComponent {
    @Input() key_name: string | null | undefined = '';
    @Input() match_status_string: string | null | undefined = '';
    @Input() match_stats_string: string | null | undefined = '';
    @Input() stats_by_set: boolean = false;
    @Input() is_upper_case: boolean = false;

    constructor(
        private appStringAPI: AppStringsService,
        public ssr: SsrlocalstoreService
    ) {

    }

    get appString(): string {
        if (!this.ssr.isClientSide) {
            return this.key_name || '';
        }

        let app_string = '';
        const keyName = (this.key_name ?? '').toString();
        const matchStatus = (this.match_status_string ?? '').toString();
        const matchStats = (this.match_stats_string ?? '').toString();

        if (keyName) {
            const key_string = keyName.toLowerCase();
            app_string = this.appStringAPI.getAppString(key_string);
        }

        if (matchStatus.length > 0) {
            app_string = this.handleMatchStatus(matchStatus);
        }

        if (matchStats.length > 0) {
            app_string = this.handleStats(matchStats) ?? '';
        }

        if (this.is_upper_case && app_string) {
            app_string = app_string.toUpperCase();
        }

        return app_string;
    }

    handleMatchStatus(match_status_string: string): string {
        switch (match_status_string) {
            case 'playing':
                return this.handleStatusKeys('TOGGLE_LIVE').toUpperCase();
            case 'finished':
            case 'finished_recently':
                return this.handleStatusKeys('FINAL').toUpperCase();
            case 'on_court':
                return this.handleStatusKeys('ON_COURT').toUpperCase();
            case 'finished_retired':
                return this.handleStatusKeys('RETIREMENT').toUpperCase();
            case 'finished_walkover':
                return this.handleStatusKeys('WALKOVER').toUpperCase();
            case 'postponed':
                return this.handleStatusKeys('POSTPONED').toUpperCase();
            default:
                return match_status_string.toUpperCase();
        }
    }

    handleStatusKeys(key_name: string): string {
        const app_string = (APP_STRING_KEYS?.get(key_name) as string) ?? key_name;
        return this.appStringAPI.getAppString(app_string);
    }

    handleStats(key_name: string): string {
        const app_string = (APP_STRING_KEYS?.get(key_name) as string) ?? key_name;

        if (!this.stats_by_set) {
            return this.appStringAPI.getAppString(app_string);
        }

        // stats_by_set mode
        const cached = this.appStringAPI.getAppString(app_string);
        if (cached !== app_string) return cached;

        // Safety check: ensure string exists before splitting
        if (!app_string) return '';

        const string_split = app_string.split('_');
        if (string_split.length > 0) {
            string_split.pop();
        }

        return string_split.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
}